export var TransactionMessageKind;
(function(TransactionMessageKind) {
    TransactionMessageKind["success"] = "transaction-client-success";
    TransactionMessageKind["fail"] = "transaction-client-failure";
})(TransactionMessageKind || (TransactionMessageKind = {}));
export var TransactionType;
(function(TransactionType) {
    TransactionType["token"] = "token";
    TransactionType["nft"] = "nft";
})(TransactionType || (TransactionType = {}));
